<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Token">
        <input class="form-input" v-model="config.auth.accessToken">
      </form-group>
    </div>

    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>

        <form-group label="Webhook produto aprovado" :columns="6">
          {{ urlWebhookProductApproved }}

          <button type="button" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="urlWebhookProductApproved">
            <i class="icon icon-copy2"></i>
          </button>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel :title="$t('order.label')">
      <div class="l-row">
        <form-group label="Sincronizar pedidos do tipo Troca">
          <label class="form-switch">
            <input type="checkbox" v-model="config.order.syncOrderTypeExchange">
            <span class="form-switch__indicator"></span>
          </label>
          <small class="form-help">Define se os pedidos do tipo 'Troca' devem ser sincronizados automaticamente.</small>
        </form-group>

        <order-retrieve-date-configuration :orderConfigs="config.order" :columns="6"/>

        <form-group label="Agrupar produtos com mesmo sku" :columns="3">
          <select class="form-select" v-model="config.order.groupProducts">
            <option v-for="option in groupProductsOptions" :key="option" :value="option">{{ $t(`${option}.label`) }}</option>
          </select>
        </form-group>
      </div>
    </panel>

    <panel title="Sincronização">
      <div class="l-row">

        <form-group label="Sincronizar estoque" :columns="3">
          <select class="form-select" v-model="config.synchronize.stock">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os estoques serão sincronizados e atualizados na Netshoes.</small>
        </form-group>

        <form-group label="Sincronizar preço" :columns="3">
          <select class="form-select" v-model="config.synchronize.price">
            <option v-for="option in synchronizeOptions" :key="option" :value="option">{{$t(`${option}.label`) }}</option>
          </select>
          <small class="form-help">Define se os preços serão sincronizados e atualizados na Netshoes.</small>
        </form-group>

      </div>
    </panel>

  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'
  import cookie from 'vue-cookie'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'netshoes'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'netshoes',
      config: {
        auth: {
          environment: 'sandbox',
          accessToken: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          syncOrderTypeExchange: false,
          retrieveDate: null,
          groupProducts: false
        },
        quotation: {
          shipmentMethod: null
        },
        synchronize: {
          stock: true,
          price: true
        }
      },
      groupProductsOptions: [
        false,
        true
      ],
      synchronizeOptions: [
        true,
        false
      ]
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ]),
      urlWebhookProductApproved () {
        let url = `https://backend.placemarket.com.br/webhook/marketplace/netshoes/product_approved/${cookie.get('merchant')}`

        if (window.location.hostname === 'localhost') {
          url = `http://localhost:3001/webhook/marketplace/netshoes/product_approved/${cookie.get('merchant')}`
        }

        return url
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Netshoes.vue?fe6f56e4